import { ApiClient } from "../utils/httpService";

interface ApiResponse<T = any> {
  data: T;
  success: boolean;
  message?: string;
}

export interface IpLookupData {
  ip?: string;
  latitude?: number | null;
  longitude?: number | null;
  city?: string | null;
  region?: string | null;
  country?: string | null;
  countryName?: string | null;
  countryCode?: string | null;
  country_code?: string | null;
  code?: string | null;
}

export const lookupIP = async (ip: any): Promise<ApiResponse> => {
  const api = new ApiClient();

  return api.request<ApiResponse<IpLookupData>>({
    method: "get",
    url: `/general/ipLookup/${ip}`,
  });
};

export const generateDynamicLink = async (payload: {
  url: string;
  image: string;
  description: string;
  title: string;
}): Promise<any> => {
  const api = new ApiClient(`${process.env.NEXT_PUBLIC_APP_LINK}`);

  return api.request<any>({
    method: "post",
    url: ``,
    data: payload,
    headers: {
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_APP_LINK_TOKEN}`,
      "Content-Type": "application/json",
    },
  });
};
